import FlowRecord from './flowRecord';
export default FlowRecord;
